import { render, staticRenderFns } from "./DriverDashboard.vue?vue&type=template&id=0486d06b&scoped=true"
import script from "./DriverDashboard.vue?vue&type=script&lang=js"
export * from "./DriverDashboard.vue?vue&type=script&lang=js"
import style0 from "./DriverDashboard.vue?vue&type=style&index=0&id=0486d06b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0486d06b",
  null
  
)

export default component.exports